import React, { useMemo, useState } from 'react';
import { debounce } from 'lodash';
import { useIntl } from 'react-intl';
import { useResizeDetector } from 'react-resize-detector';
import {
  ExpandableSearch,
  SEARCH_MIN_CHAR_LENGTH,
} from '@rossum/components/expandable-search/ExpandableSearch';
import { Stack } from '@rossum/ui/material';
import { toolbarStyles } from '../constants';

type Props = {
  onSearchSubmit: (searchValue: string | undefined) => void;
  search: string | undefined;
};

const Toolbar = React.memo(({ onSearchSubmit, search }: Props) => {
  const intl = useIntl();
  const { width, ref } = useResizeDetector();
  const [searchState, setSearchState] = useState(search ?? '');

  const debouncedSearching = useMemo(
    () => debounce(onSearchSubmit, 400),
    [onSearchSubmit]
  );

  return (
    <Stack
      {...toolbarStyles}
      sx={{ ...toolbarStyles.sx, flex: 1, justifyContent: 'flex-end' }}
    >
      <Stack sx={{ flex: 1, alignItems: 'flex-end' }} ref={ref}>
        <ExpandableSearch
          onChange={newSearch => {
            setSearchState(newSearch);
            debouncedSearching(
              newSearch.length >= SEARCH_MIN_CHAR_LENGTH ? newSearch : undefined
            );
          }}
          value={searchState}
          targetWidth={width ? Math.min(width, 300) : undefined}
          placeholder={intl.formatMessage({
            id: 'components.dashboard.queues.search',
          })}
        />
      </Stack>
    </Stack>
  );
});

export { Toolbar };
